import React, { useRef, useState } from 'react';
import { Overlay, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

const TransactionDateTooltip = (props) => {
    const { content, extra } = props;
    return (
        <div style={{ cursor: 'pointer' }}>
            <OverlayTrigger
                placement="top"
                overlay={
                    // eslint-disable-next-line react/jsx-one-expression-per-line
                    <Tooltip id={Math.random()}>{extra}</Tooltip>
                }
            >
                <span>
                    {content}
                </span>
            </OverlayTrigger>
        </div>
    );
};

export default TransactionDateTooltip;



/** WEBPACK FOOTER **
 ** ./src/components/k-wallet/transaction-date-tooltip.jsx
 **/